export function saveTokens(params) {
  localStorage.setItem("access_token", params.access_token);
  localStorage.setItem("refresh_token", params.refresh_token);
}

export function clearTokens() {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
}

export function getAccessToken() {
  return localStorage.getItem("access_token");
}
